export default __webpack_public_path__ + "static/media/restaurant_info_card_sample.80718a45.png";